import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { doCreateMessage } from 'zengenti-forms-package/utils/transform-utils';

const CharacterLimitStyled = styled.div`
  ${({ theme, useDefaultTheme }) => {
    return css`
      display: block;
      ${useDefaultTheme &&
        css`
          font-size: 14px;
          color: ${theme.colors.neutrals.empress_gray};
          font-weight: 400;
          line-height: 24px;
          text-align: right;
          max-width: 320px;
          width: 100%;
        `}
    `;
  }};
`;

export const CharacterLimit = ({
  className,
  value,
  validations,
  defaultLanguage,
  useDefaultTheme,
}) => {
  if (!validations) return null;
  let valueAsString = typeof value === 'number' ? value.toString() : value;
  const currentLength =
    valueAsString && valueAsString.length ? valueAsString.length : 0;
  const { minLength, maxLength } = validations;
  const hasMaxLength = maxLength && !minLength;
  const hasMinLength = minLength && !maxLength;
  const hasInBetween = minLength && maxLength;
  const type = hasMinLength
    ? 'min'
    : hasMaxLength
    ? 'max'
    : hasInBetween
    ? 'between'
    : null;
  if (!type) return null;
  return (
    <CharacterLimitStyled
      className={className}
      useDefaultTheme={useDefaultTheme}
    >
      {doCreateMessage(
        type,
        minLength,
        maxLength,
        currentLength,
        defaultLanguage
      )}
    </CharacterLimitStyled>
  );
};

CharacterLimit.propTypes = {
  validations: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  defaultLanguage: PropTypes.string,
  useDefaultTheme: PropTypes.bool,
};
